import React from "react";
import "./terms.css";

import logoWhite from './logo_white.png';

const CookiesPolicy = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top px-3">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              src={logoWhite}
              alt="KeyConnect Logo"
              style={{ height: "40px", marginLeft: "20px" }}
            />
          </a>
        </div>
      </nav>

      <section className="legal-page">
        <div className="wrap">
          <h1>Cookies Policy</h1>

          <div className="legal-meta">
            <div>
              <strong>Effective Date:</strong> 8<sup>th</sup> July 2025
            </div>
            <div>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </div>
            <div>
              <strong>Platform:</strong> KeyConnect CRM
            </div>
          </div>

          <p>
            This Cookies Policy explains how <strong>KeyConnect CRM</strong>{" "}
            ("we", "our", or "us") uses cookies and similar tracking
            technologies when you visit our website:{" "}
            <a
              href="https://www.keyconnect.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.keyconnect.in
            </a>{" "}
            ("Website").
          </p>

          <p>
            By using our Website, you agree to the use of cookies as
            described in this policy.
          </p>

          <section>
            <h2>1. What Are Cookies?</h2>
            <p>
              Cookies are small text files stored on your device (computer,
              tablet, mobile) by websites you visit. They help websites
              function properly, remember your preferences, and collect
              analytical data for improving services.
            </p>
          </section>

          <section>
            <h2>2. Types of Cookies We Use</h2>
            <p>We use the following categories of cookies on our Website:</p>

            <p>
              <strong>a. Strictly Necessary Cookies</strong>
            </p>
            <p>
              These cookies are essential for the operation of the Website.
              They enable you to log in, submit forms, and navigate pages
              securely.
            </p>

            <p>
              <strong>b. Performance &amp; Analytics Cookies</strong>
            </p>
            <p>
              These cookies collect anonymous data about how visitors use
              our Website (e.g., pages visited, session duration). They help
              us improve functionality and user experience. We may use
              tools like Google Analytics.
            </p>

            <p>
              <strong>c. Functional Cookies</strong>
            </p>
            <p>
              These cookies allow the Website to remember choices you make
              (e.g., language, login sessions) to offer enhanced
              functionality.
            </p>

            <p>
              <strong>d. Third-Party Cookies</strong>
            </p>
            <p>
              Some features or integrations (e.g., embedded videos, chat
              widgets, social media plugins) may use third-party cookies.
              These are subject to the policies of the respective providers.
            </p>
          </section>

          <section>
            <h2>3. How We Use Cookies</h2>
            <p>We use cookies to:</p>
            <ul>
              <li>Ensure platform security and proper functioning</li>
              <li>Understand visitor behaviour and measure site performance</li>
              <li>Remember user preferences and login status</li>
              <li>Deliver relevant content and experiences</li>
            </ul>
            <p>
              We do <strong>not</strong> use cookies to track you across
              unrelated third-party websites.
            </p>
          </section>

          <section>
            <h2>4. Managing Cookies</h2>
            <p>
              You can control and manage cookie settings through your
              browser. Most browsers allow you to:
            </p>
            <ul>
              <li>View, delete, or block cookies</li>
              <li>Receive a warning before cookies are stored</li>
              <li>Disable all cookies (note: this may impact site functionality)</li>
            </ul>
            <p>
              To learn more about controlling cookies, visit{" "}
              <a
                href="https://www.allaboutcookies.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.allaboutcookies.org
              </a>
              .
            </p>
          </section>

          <section>
            <h2>5. Changes to This Policy</h2>
            <p>
              We may update this Cookies Policy from time to time. Any
              changes will be posted on this page with a revised "Effective
              Date."
            </p>
          </section>

          <section>
            <h2>6. Contact Us</h2>
            <p>
              If you have any questions about this Cookies Policy or our use
              of cookies, please contact:
            </p>
            <p>
              <strong>KeyConnect CRM – Privacy Team</strong>
              <br />
              Email: <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>
              <br />
              Website:{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </p>
          </section>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-light text-center py-4">
        <small>
          &copy; {new Date().getFullYear()} KeyConnect CRM. All rights reserved.
        </small>
      </footer>
    </div>
  );
};

export default CookiesPolicy;